import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { AvgAnalyticsModel } from '../models/AvgAnalyticsModel';

const avgAnalyticsCategoryAdapter = createEntityAdapter();

export const avgAnalyticsCategoryApi = {
    _getToken: (thunkAPI) => {
        return thunkAPI.getState().identityReducer.token.signature;
    },
    fetchAll: createAsyncThunk(
        'avgAnalyticsCategory/fetchAll',
        async ({ page, term, sorting, filters, avgType }, thunkAPI) => {
            try {
                const token = avgAnalyticsCategoryApi._getToken(thunkAPI);
                const avgAnalyticsModel = new AvgAnalyticsModel(token, AvgAnalyticsModel.TYPE_FASHION);

                /** @type {Pager} */
                const pager = await avgAnalyticsModel.getAnalytics(
                    page, term, sorting, filters, avgType, AvgAnalyticsModel.TAXONOMY.category);

                return {
                    hasPrevPage: pager.hasPrevPage,
                    hasNextPage: pager.hasNextPage,
                    entities: pager.getEntities()
                }
            } catch (apiError) {
                return thunkAPI.rejectWithValue(apiError.toJson());
            }
        }
    ),
}

const avgAnalyticsCategorySlice = createSlice({
    name: "avgAnalyticsBrand",
    initialState: avgAnalyticsCategoryAdapter.getInitialState({
        status: 'idle',
        error: null,
        avgType: null,
        term: null,
        sorting: null,
        filters: {
            categoryCode: null,
        },
        showMore: true,
        clearListOnResponse: false,
    }),
    reducers: {
        setAvgType(state, action) {
            state.avgType = action.payload
        },
        setSorting(state, action) {
            state.sorting = action.payload;
        },
        setFilters(state, action) {
            state.filters = action.payload;
        },
        clearAvgAnalytics(state) {
            state.clearListOnResponse = true
        },
    },
    extraReducers: {
        [avgAnalyticsCategoryApi.fetchAll.pending]: (state, action) => {
            state.status = 'avgAnalyticsCategory/fetchAll/pending';
        },
        [avgAnalyticsCategoryApi.fetchAll.fulfilled]: (state, action) => {
            state.status = 'avgAnalyticsCategory/fetchAll/succeeded';
            if(state.clearListOnResponse) {
                avgAnalyticsCategoryAdapter.setAll(state, action.payload.entities)
            } else {
                avgAnalyticsCategoryAdapter.addMany(state, action.payload.entities)
            }
            state.clearListOnResponse = false
            state.showMore = action.payload.hasNextPage;
            state.error = null;
        },
        [avgAnalyticsCategoryApi.fetchAll.rejected]: (state, action) => {
            state.status = 'avgAnalyticsCategory/fetchAll/rejected';
            state.error = action.payload;
        },
    }
});

export const {
    selectById: selectAnalyticsById,
    selectAll: selectAllAnalytics,
} = avgAnalyticsCategoryAdapter.getSelectors((state) => state.avgAnalyticsCategoryReducer)

export const { setAvgType, setSorting, setFilters, clearAvgAnalytics } = avgAnalyticsCategorySlice.actions;

export default avgAnalyticsCategorySlice.reducer;